import { createCodebookSelector } from '@/modules/codebooks';

/**
 * Selektor kategorie ubytování — položky číselníku z kategorie (Folder) „AccommodationCategory",
 * tj. hodnoty nastavitelné do `Placeholder.AccommodationCategoryCbID`.
 */
const accommodationCategorySelector = createCodebookSelector('AccommodationCategory');

export const AccommodationCategorySelector = accommodationCategorySelector.Selector;
export const AccommodationCategorySelectorField = accommodationCategorySelector.Field;
